import { storageLocationIdFormat } from "@redotech/redo-ids-cockroach";
import * as z from "zod";
import { CountedItemSchema } from "./confirm-bin-count";

export const confirmDirectBinCount = {
  name: "confirmDirectBinCount" as const,
  input: z.object({
    storageLocationId: storageLocationIdFormat.schema,
    countedItems: z.array(CountedItemSchema).max(10_000),
    partialCount: z.boolean().optional(),
  }),
  output: z.object({ success: z.boolean() }),
};
